export const download = (data: any, type: string, fileName: string) => {
    const blob = new Blob([data], { type })
    const url: string = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    URL.revokeObjectURL(url)
    a.remove()
  }